<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card >
      <div class="tw-flex tw-justify-between">
        <vs-select
            class=""
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>

        <vs-paginator
            v-if="meta"
            :meta="meta"
            @change="handlePageChange"
        ></vs-paginator>

      </div>
    </vs-card>

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>Admin Düzenleme</h3>

         
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
        
        
      <vs-button class="editbutons"  :to="{name: 'institutions-index'}"type="line">Destekleyen Diğer Kurum Ekle</vs-button>
        <vs-button  class="editbutons" :to="{name: 'events-index'}" type="line">Diğer Etkinlik Türü Ekle</vs-button>
        <vs-button class="editbutons"  type="line">Diğer Salon Ekle</vs-button>
        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>
        
        <div class="tw-w-full lg:tw-w-2/5">
          <div v-if="loading">Yükleniyor...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Liste</h3>
            </template>
            <template slot="thead">
             
              <vs-th>Diğer Salon</vs-th>
                <vs-th></vs-th>
                 <vs-th></vs-th>
                
              
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(item, i) in data" :key="i" >
                
                 
                 <vs-td :data="item.room">
                  <div class="fontt" @click="show(item, i)">{{ item.room }}</div>
                </vs-td>
                
                 <vs-td :data="item">
                <vs-button  color="#46c93a" icon-pack="mdi" icon="mdi-favorite" @click='onayla(item)'>Onayla</vs-button>
                </vs-td>
                 <vs-td :data="item">
                <vs-button  color="#ff4757" icon-pack="mdi" icon="mdi-favorite" @click='sil(item)'>Listeden Sil</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

         
        </div>
 
        <div  class="tw-w-full lg:tw-w-1/2 lg:tw-pl-5">
          <!--<vs-card v-if="selected">
            <div slot="header">
              <h3>{{ selected.room }}</h3>
            </div>
            <div>
              {{ selected.description }}

              <div>
                <strong>Durum: </strong> {{ obj.columns.published ? "Kaydedildi" : "Kaydedilmedi" }}
              </div>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button type="gradient" color="success" icon-pack="mdi" icon="mdi-favorite" @click='onayla(selected.room)'>Onayla</vs-button>
             
                <vs-button type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite" @click='sil(selected.room)'>Listeden Sil</vs-button>
              </vs-row>
            </div>
          </vs-card> -->
          <!--
          <div v-else>
            <br />
            <vs-alert active="true" color="info">
              Onaylamak için "diğer salon" seçiniz.
            </vs-alert>
          </div>-->

        </div>

      </div>

    </vs-card>

  </div>
</template>

<script>
  import { paginatorMixin } from "@/mixins/paginatorMixin";
  import Room from "@/libs/rooms/Room";
  import Roo from "@/libs/roos/Roo";

  export default {
    name: "rooms-index",
    title: "Salon Onay",

    mixins: [
      paginatorMixin,
    ],

    data() {
      return {
        obj: new Room(),
        obj2: new Roo(),
        search: "",
        loading: false,
        kurumbool:true,
        etkinlikbool:false,
        salonbool:false,
      };
    },

    computed: {
      rooms() {
        return this.obj.rooms
      },

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      list() {
        if(this.rooms && this.rooms.data){
            return this.rooms.data

        }
          
        return []
      },

      meta() {
        if(this.rooms && this.rooms.meta)
          return this.rooms.meta

        return null
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },
 
    methods: {
      sil(item){
        this.$confirm(
        {
          message: `Diğer Salon'u Silmek İstiyor musunuz?`,
          button: {
            no: 'Hayır',
            yes: 'Evet'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm
          */
          callback: confirm => {
            if (confirm) {
             
              
       
           this.obj.delete(item.id)
            }
          }
        }
      )
      },
      onayla(item){
        this.$confirm(
        {
          message: `Diğer Salon'u Onaylamak İstiyor musunuz?`,
          button: {
            no: 'Hayır',
            yes: 'Evet'
          },
          /**
          * Callback Function
          * @param {Boolean} confirm
          */
          callback: confirm => {
            if (confirm) {
             
              
        this.obj2.columns.roo=item.room
         this.obj2.create()
           this.obj.delete(item.id)
            }
          }
        }
      )
      },
       
      kurum(){
          this.kurumbool=true;
          this.etkinlikbool=false;
          this.salonbool=false;
      },
      etkinlik(){
          this.kurumbool=false;
          this.etkinlikbool=true;
          this.salonbool=false;
      },
      salon(){
          this.kurumbool=false;
          this.etkinlikbool=false;
          this.salonbool=true;
      },
      get() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          this.pageSize
        );

        
        this.obj.getAll(params)
      },

      handlePageChange(page) {
        this.page = page;
        this.get();
      },

      handlePageSizeChange() {
        this.page = 1;
        this.get();
      },

      refreshList() {
        this.get();
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        this.loading = true
        this.obj.deleteAll()
      },
    },
     beforeMount(){
    
      //this.$options2= getAll()  
      //console.log(this.obj.columns.inst)
      
    },
    
    mounted() {
      this.get();
    }
  };
</script>

<style>
  .vs-component.vs-button.vs-button-danger.vs-button-gradient{
    color:white;
  }
  .vs-component.vs-button.vs-button-primary.vs-button-filled{
    color:white;
  }
  .vs-component.vs-button.vs-button-null.vs-button-filled{
    color:white;
  }
  .editbutons{
    margin-left: 13%;
     margin-top: 2%;
   border-style: solid;
  border-width: 2px;
  border-radius: 15px;
  }
  .vs-pagination--li.is-current .effect{
      background-color: #E6272D !important;
      border-radius:25px;
  }

  .paginat{
  display: none;
}
</style>